"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _data = require("../config/data");

var _datepicker_compact_props = _interopRequireDefault(require("../datepicker_compact_props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var DatePanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DatePanel, _PureComponent);

  function DatePanel(props) {
    var _this;

    _classCallCheck(this, DatePanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePanel).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  } // 初始化相关的time


  _createClass(DatePanel, [{
    key: "getTimeInfo",
    value: function getTimeInfo() {
      var _this$props = this.props,
          optionalStartDateData = _this$props.optionalStartDateData,
          optionalEndDateData = _this$props.optionalEndDateData,
          _this$props$startData = _this$props.startData,
          startData = _this$props$startData === void 0 ? {} : _this$props$startData,
          _this$props$endData = _this$props.endData,
          endData = _this$props$endData === void 0 ? {} : _this$props$endData;
      var optionalStartDateTime = new Date(optionalStartDateData.year, optionalStartDateData.month, optionalStartDateData.date).getTime();
      var optionalEndDateTime = new Date(optionalEndDateData.year, optionalEndDateData.month, optionalEndDateData.date).getTime();
      var _startData$year = startData.year,
          startYear = _startData$year === void 0 ? 0 : _startData$year,
          _startData$month = startData.month,
          startMonth = _startData$month === void 0 ? 0 : _startData$month,
          _startData$date = startData.date,
          startDate = _startData$date === void 0 ? 0 : _startData$date;
      var _endData$year = endData.year,
          endYear = _endData$year === void 0 ? 0 : _endData$year,
          _endData$month = endData.month,
          endMonth = _endData$month === void 0 ? 0 : _endData$month,
          _endData$date = endData.date,
          endDate = _endData$date === void 0 ? 0 : _endData$date;
      var startDateTime = new Date(startYear, startMonth, startDate).getTime();
      var endDateTime = new Date(endYear, endMonth, endDate).getTime();
      return {
        optionalStartDateTime: optionalStartDateTime,
        optionalEndDateTime: optionalEndDateTime,
        startDateTime: startDateTime,
        endDateTime: endDateTime
      };
    } // 当前日期是否能用

  }, {
    key: "canUse",
    value: function canUse(year, month, date) {
      var _compactProps = (0, _datepicker_compact_props["default"])(this.props),
          type = _compactProps.type,
          startDateDisabled = _compactProps.startDateDisabled,
          endDateDisabled = _compactProps.endDateDisabled,
          _compactProps$startDa = _compactProps.startData,
          startData = _compactProps$startDa === void 0 ? {} : _compactProps$startDa,
          _compactProps$endData = _compactProps.endData,
          endData = _compactProps$endData === void 0 ? {} : _compactProps$endData,
          shortestRange = _compactProps.shortestRange,
          longestRange = _compactProps.longestRange,
          startDateCanBeUnlimited = _compactProps.startDateCanBeUnlimited,
          unlimitedDateValue = _compactProps.unlimitedDateValue,
          format = _compactProps.format,
          getDateValue = _compactProps.getDateValue,
          optionalStartDateData = _compactProps.optionalStartDateData,
          optionalEndDateData = _compactProps.optionalEndDateData,
          endDateCanBeUnlimited = _compactProps.endDateCanBeUnlimited;

      var _this$getTimeInfo = this.getTimeInfo(),
          optionalStartDateTime = _this$getTimeInfo.optionalStartDateTime,
          optionalEndDateTime = _this$getTimeInfo.optionalEndDateTime,
          startDateTime = _this$getTimeInfo.startDateTime,
          endDateTime = _this$getTimeInfo.endDateTime;

      var currentDateTime = new Date(year, month, date).getTime();

      var theTimeInRange = function theTimeInRange() {
        var beginTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return currentDateTime >= beginTime && currentDateTime <= endTime;
      };

      var result = true;
      var tempData = {};
      var spaceTime = 0; // 小于可选日期肯定都不能用了

      if (!theTimeInRange(optionalStartDateTime, optionalEndDateTime)) {
        result = false;
      } else {
        // 开始日期禁止变更的情况
        if (startDateDisabled) {
          // 禁止开始日期
          if (!theTimeInRange(startDateTime + _data.ONE_DAY_TIME * shortestRange, startDateTime + _data.ONE_DAY_TIME * longestRange)) {
            result = false;
          }
        } // 结束日期禁止变更的情况


        if (result && endDateDisabled) {
          // 禁止开始日期
          if (!theTimeInRange(endDateTime - _data.ONE_DAY_TIME * longestRange, endDateTime - _data.ONE_DAY_TIME * shortestRange)) {
            result = false;
          }
        } // 选择一个日期后，不能保证在选择范围的，都是false


        if ((type === 'start' || type === 'end') && result) {
          if (startData.year && !endData.year || endData.year && !startData.year) {
            if (startData.year) {
              // 如果开始日期是无限的，那就用可选开始日期作为判断依据
              if (startDateCanBeUnlimited && (0, _spauiUtils.joinDate)(startData, format) === getDateValue('startDate', unlimitedDateValue)) {
                tempData = optionalStartDateData;
              } else {
                tempData = startData;
              }
            } else {
              // 如果开始日期是无限的，那就用可选开始日期作为判断依据
              if (endDateCanBeUnlimited && (0, _spauiUtils.joinDate)(endData, format) === getDateValue('endDate', unlimitedDateValue)) {
                tempData = optionalEndDateData;
              } else {
                tempData = endData;
              }
            }

            spaceTime = Math.abs(currentDateTime - new Date(tempData.year, tempData.month, tempData.date).getTime());

            if (shortestRange > 0 && spaceTime < shortestRange * _data.ONE_DAY_TIME) {
              result = false;
            } else if (longestRange > 0 && spaceTime > longestRange * _data.ONE_DAY_TIME) {
              result = false;
            }
          }
        }
      }

      return result;
    } // 获取上个月的日期数据

  }, {
    key: "getLastMonthDateData",
    value: function getLastMonthDateData(year, month) {
      var _this$props2 = this.props,
          type = _this$props2.type,
          _this$props2$startDat = _this$props2.startData,
          startData = _this$props2$startDat === void 0 ? {} : _this$props2$startDat,
          _this$props2$endData = _this$props2.endData,
          endData = _this$props2$endData === void 0 ? {} : _this$props2$endData,
          propsStartYear = _this$props2.startYear,
          propsStartMonth = _this$props2.startMonth,
          hideEndDatePanel = _this$props2.hideEndDatePanel,
          panelWeekStart = _this$props2.panelWeekStart;
      var _startData$year2 = startData.year,
          startYear = _startData$year2 === void 0 ? 0 : _startData$year2,
          _startData$month2 = startData.month,
          startMonth = _startData$month2 === void 0 ? 0 : _startData$month2,
          _startData$date2 = startData.date,
          startDate = _startData$date2 === void 0 ? 0 : _startData$date2;
      var _endData$year2 = endData.year,
          endYear = _endData$year2 === void 0 ? 0 : _endData$year2,
          _endData$month2 = endData.month,
          endMonth = _endData$month2 === void 0 ? 0 : _endData$month2,
          _endData$date2 = endData.date,
          endDate = _endData$date2 === void 0 ? 0 : _endData$date2;
      var weekDate = new Date(year, month, 1);
      var firstDayOfWeek = weekDate.getDay();

      var _this$getTimeInfo2 = this.getTimeInfo(),
          startDateTime = _this$getTimeInfo2.startDateTime,
          endDateTime = _this$getTimeInfo2.endDateTime;

      var result = [];
      var lastMonthDays = 0;
      var lastYear = 0;
      var lastMonth = 0;
      var lastDate = 0;
      var currentDateData = {};
      var currentDateTime = 0; // 如果这个月第一天的日期恰好不是指定的周的起始，则需要补充上个月的日期

      if (firstDayOfWeek > panelWeekStart) {
        // 获得上一个月的年与月信息
        if (month === 0) {
          lastYear = year - 1;
          lastMonth = 11;
        } else {
          lastYear = year;
          lastMonth = month - 1;
        } // 上个月有多少天


        lastMonthDays = new Date(lastYear, lastMonth + 1, 0).getDate(); // 需要补充上个月的天数

        var appendDayNumber = firstDayOfWeek - panelWeekStart;

        for (var i = 0; i < appendDayNumber; i++) {
          // 上个月对应的某一天
          lastDate = lastMonthDays - i;
          currentDateData = {
            lastMonth: true,
            disabled: !this.canUse(lastYear, lastMonth, lastDate),
            year: lastYear,
            month: lastMonth,
            date: lastDate
          }; // 另外个面板不是上个月才做选中展示

          if (type === 'end' && !(lastYear === propsStartYear && lastMonth === propsStartMonth) || type === 'start' || hideEndDatePanel) {
            // 处于选中时间的中间过程
            if (Math.abs(startDateTime) > 0 && endDateTime > 0) {
              currentDateTime = new Date(lastYear, lastMonth, lastDate).getTime();

              if (currentDateTime > startDateTime && currentDateTime < endDateTime) {
                currentDateData.among = true;
              }
            } // 开始日期选中


            if (lastYear === startYear && lastMonth === startMonth && lastDate === startDate) {
              delete currentDateData.among;
              currentDateData.startDate = true;
              currentDateData.on = true;
            } // 结束日期选中


            if (lastYear === endYear && lastMonth === endMonth && lastDate === endDate) {
              delete currentDateData.among;
              currentDateData.endDate = true;
              currentDateData.on = true;
            }
          }

          result.unshift(currentDateData);
        }
      }

      return result;
    } // 获取下个月的日期

  }, {
    key: "getNextMonthDateData",
    value: function getNextMonthDateData(year, month) {
      var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$props3 = this.props,
          type = _this$props3.type,
          _this$props3$startDat = _this$props3.startData,
          startData = _this$props3$startDat === void 0 ? {} : _this$props3$startDat,
          _this$props3$endData = _this$props3.endData,
          endData = _this$props3$endData === void 0 ? {} : _this$props3$endData,
          hideEndDatePanel = _this$props3.hideEndDatePanel,
          propsEndYear = _this$props3.endYear,
          propsEndMonth = _this$props3.endMonth;
      var _startData$year3 = startData.year,
          startYear = _startData$year3 === void 0 ? 0 : _startData$year3,
          _startData$month3 = startData.month,
          startMonth = _startData$month3 === void 0 ? 0 : _startData$month3,
          _startData$date3 = startData.date,
          startDate = _startData$date3 === void 0 ? 0 : _startData$date3;
      var _endData$year3 = endData.year,
          endYear = _endData$year3 === void 0 ? 0 : _endData$year3,
          _endData$month3 = endData.month,
          endMonth = _endData$month3 === void 0 ? 0 : _endData$month3,
          _endData$date3 = endData.date,
          endDate = _endData$date3 === void 0 ? 0 : _endData$date3;

      var _this$getTimeInfo3 = this.getTimeInfo(),
          startDateTime = _this$getTimeInfo3.startDateTime,
          endDateTime = _this$getTimeInfo3.endDateTime;

      var result = [];
      var i = 0;
      var nextYear = 0;
      var nextMonth = 0;
      var nextDate = 0;
      var currentDateData = {};
      var currentDateTime = 0;

      if (len > 0) {
        // 获得上一个月的年与月信息
        if (month === 11) {
          nextYear = year + 1;
          nextMonth = 0;
        } else {
          nextYear = year;
          nextMonth = month + 1;
        }

        for (; i < len; i++) {
          nextDate = i + 1;
          currentDateData = {
            nextMonth: true,
            year: nextYear,
            month: nextMonth,
            disabled: !this.canUse(nextYear, nextMonth, nextDate),
            date: nextDate
          }; // 另外个面板不是下个月才做选中展示

          if (type === 'start' && !(nextYear === propsEndYear && nextMonth === propsEndMonth) || type === 'end' || hideEndDatePanel) {
            // 处于选中时间的中间过程
            if (Math.abs(startDateTime) > 0 && endDateTime > 0) {
              currentDateTime = new Date(nextYear, nextMonth, nextDate).getTime();

              if (currentDateTime > startDateTime && currentDateTime < endDateTime) {
                currentDateData.among = true;
              }
            } // 开始日期选中


            if (nextYear === startYear && nextMonth === startMonth && i === startDate - 1) {
              delete currentDateData.among;
              currentDateData.startDate = true;
              currentDateData.on = true;
            } // 结束日期选中


            if (nextYear === endYear && nextMonth === endMonth && i === endDate - 1) {
              delete currentDateData.among;
              currentDateData.endDate = true;
              currentDateData.on = true;
            }
          }

          result.push(currentDateData);
        }
      }

      return result;
    } // 获取日期数据

  }, {
    key: "getData",
    value: function getData() {
      var _this$props4 = this.props,
          year = _this$props4.year,
          _this$props4$month = _this$props4.month,
          month = _this$props4$month === void 0 ? 0 : _this$props4$month,
          _this$props4$dateData = _this$props4.dateData,
          dateData = _this$props4$dateData === void 0 ? {} : _this$props4$dateData,
          _this$props4$startDat = _this$props4.startData,
          startData = _this$props4$startDat === void 0 ? {} : _this$props4$startDat,
          _this$props4$endData = _this$props4.endData,
          endData = _this$props4$endData === void 0 ? {} : _this$props4$endData,
          type = _this$props4.type,
          hoverYear = _this$props4.hoverYear,
          hoverMonth = _this$props4.hoverMonth,
          hoverDate = _this$props4.hoverDate,
          useNewUI = _this$props4.useNewUI;
      var _dateData$year = dateData.year,
          singleYear = _dateData$year === void 0 ? 0 : _dateData$year,
          singleMonth = dateData.month,
          _dateData$date = dateData.date,
          singleDate = _dateData$date === void 0 ? 0 : _dateData$date;
      var _startData$year4 = startData.year,
          startYear = _startData$year4 === void 0 ? 0 : _startData$year4,
          _startData$month4 = startData.month,
          startMonth = _startData$month4 === void 0 ? 0 : _startData$month4,
          _startData$date4 = startData.date,
          startDate = _startData$date4 === void 0 ? 0 : _startData$date4;
      var _endData$year4 = endData.year,
          endYear = _endData$year4 === void 0 ? 0 : _endData$year4,
          _endData$month4 = endData.month,
          endMonth = _endData$month4 === void 0 ? 0 : _endData$month4,
          _endData$date4 = endData.date,
          endDate = _endData$date4 === void 0 ? 0 : _endData$date4;

      var _this$getTimeInfo4 = this.getTimeInfo(),
          startDateTime = _this$getTimeInfo4.startDateTime,
          endDateTime = _this$getTimeInfo4.endDateTime;

      var today = new Date();
      var todayYear = today.getFullYear();
      var todayMonth = today.getMonth();
      var todayDate = today.getDate();
      var currentDateTime = 0;
      var i = 0;
      var days = 0;
      var currentDateData = {};
      var result = []; // 上个月的日期

      result = this.getLastMonthDateData(year, month); // 这个月的日期，都为可用数据

      i = 0;
      days = new Date(year, month + 1, 0).getDate();

      for (; i < days; i++) {
        currentDateData = {
          year: year,
          month: month,
          disabled: !this.canUse(year, month, i + 1),
          date: i + 1
        }; // 该日期是否是今天

        if (useNewUI && year == todayYear && month == todayMonth && i + 1 == todayDate) {
          currentDateData.today = true;
        }

        if (type === 'single') {
          // 开始日期选中
          if (year === singleYear && month === singleMonth && i === singleDate - 1) {
            currentDateData.on = true;
          }
        } else if (type === 'start' || type === 'end') {
          // 处于选中时间的中间过程
          if (Math.abs(startDateTime) > 0 && endDateTime > 0) {
            currentDateTime = new Date(year, month, i + 1).getTime();

            if (currentDateTime > startDateTime && currentDateTime < endDateTime) {
              currentDateData.among = true;
            }
          } // 开始日期选中


          if (year === startYear && month === startMonth && i === startDate - 1) {
            delete currentDateData.among;
            currentDateData.startDate = true;
            currentDateData.on = true;
          } // 结束日期选中


          if (year === endYear && month === endMonth && i === endDate - 1) {
            delete currentDateData.among;
            currentDateData.endDate = true;
            currentDateData.on = true;
          } // 只选中了起始日期，结束日期未选中, 或者选中了结束日期，起始日期未选中


          var startIsZero = startYear === 0 && startMonth === 0 && startDate === 0;
          var endIsZero = endYear === 0 && endMonth === 0 && endDate === 0;

          if (!startIsZero && endIsZero) {
            // 选中的开始日期到鼠标 hover 日期之前的过程
            if (Math.abs(startDateTime) > 0) {
              currentDateTime = new Date(year, month, i + 1).getTime();
              var hoverDateTime = new Date(hoverYear, hoverMonth, hoverDate).getTime();
              var lessHoverDateTime = currentDateTime > startDateTime && currentDateTime < hoverDateTime;
              var moreHoverDateTime = currentDateTime < startDateTime && currentDateTime > hoverDateTime;

              if (lessHoverDateTime || moreHoverDateTime) {
                if (this.canUse(year, month, i + 1)) {
                  currentDateData.among = true;
                }
              }
            }
          }
        }

        result.push(currentDateData);
      } // 下个月的日期，固定6行，剩下的由下个月的补齐


      result = result.concat(this.getNextMonthDateData(year, month, 42 - result.length));
      return result;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props5 = this.props,
          onChange = _this$props5.onChange,
          type = _this$props5.type,
          onYearAndMonthChange = _this$props5.onYearAndMonthChange;
      var disabled = data.disabled;

      if (!disabled && (0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, type, data); // 如果选择的是上下个月，面板需要切换

        if ((0, _spauiUtils.isFunction)(onYearAndMonthChange)) {
          onYearAndMonthChange(event, data);
        }
      }
    } // 当鼠标 hover 到某一天

  }, {
    key: "onMouseEnterDay",
    value: function onMouseEnterDay() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var year = data.year,
          month = data.month,
          date = data.date;
      var changeHoverDate = this.props.changeHoverDate;
      changeHoverDate && changeHoverDate(year, month, date);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var data = this.getData();
      var _this$props6 = this.props,
          _this$props6$classNam = _this$props6.classNameMap,
          classNameMap = _this$props6$classNam === void 0 ? {} : _this$props6$classNam,
          panelWeekStart = _this$props6.panelWeekStart,
          type = _this$props6.type,
          locale = _this$props6.locale;
      var weekList = panelWeekStart == 0 ? locale.weekListMapBySunDay : locale.weekListMapByMonDay;
      var enableHoverDate = type === 'start' || type === 'end';
      return _react["default"].createElement("div", {
        className: classNameMap.DatePickerDateItemClassName
      }, _react["default"].createElement("ul", {
        className: "clearfix ".concat(classNameMap.DatePickerWeekListClassName)
      }, weekList.map(function (item) {
        return _react["default"].createElement("li", {
          key: item
        }, item);
      })), _react["default"].createElement("ul", {
        className: "clearfix ".concat(classNameMap.DatePickerDateListClassName)
      }, data.map(function (item, index) {
        var _classNames;

        return _react["default"].createElement("li", {
          key: "".concat(item.year, "-").concat(item.month, "-").concat(item.date, "-").concat(index),
          className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerLastMonthDateItemClassName, item.lastMonth), _defineProperty(_classNames, classNameMap.DatePickerNextMonthDateItemClassName, item.nextMonth), _defineProperty(_classNames, classNameMap.DatePickerDateItemDisabledClassName, item.disabled && !item.on), _defineProperty(_classNames, classNameMap.DatePickerDateItemSelectedClassName, item.on), _defineProperty(_classNames, classNameMap.DatePickerStartDateItemClassName, item.startDate), _defineProperty(_classNames, classNameMap.DatePickerEndDateItemClassName, item.endDate), _defineProperty(_classNames, classNameMap.DatePickerAmongDateItemClassName, item.among), _defineProperty(_classNames, classNameMap.DatePickerDateItemTodayClassName, item.today), _classNames))
        }, _react["default"].createElement("a", {
          className: (0, _classnames["default"])({
            'spaui-datepicker-pointer': (0, _spauiUtils.isUndefined)(item.disabled) || !item.disabled
          }),
          onClick: function onClick(event) {
            return _this2.handleChange(event, (0, _spauiUtils.objectAssign)({}, item));
          },
          onMouseEnter: enableHoverDate ? function () {
            return _this2.onMouseEnterDay(item);
          } : undefined
        }, item.date));
      })));
    }
  }]);

  return DatePanel;
}(_react.PureComponent);

_defineProperty(DatePanel, "propTypes", {
  type: _spauiUtils.PropTypes.string,
  year: _spauiUtils.PropTypes.number,
  month: _spauiUtils.PropTypes.number,
  dateData: _spauiUtils.PropTypes.object,
  startData: _spauiUtils.PropTypes.object,
  endData: _spauiUtils.PropTypes.object,
  onChange: _spauiUtils.PropTypes.func,
  onYearAndMonthChange: _spauiUtils.PropTypes.func,
  startDateDisabled: _spauiUtils.PropTypes.bool,
  endDateDisabled: _spauiUtils.PropTypes.bool,
  hoverYear: _spauiUtils.PropTypes.number,
  hoverMonth: _spauiUtils.PropTypes.number,
  hoverDate: _spauiUtils.PropTypes.number,
  changeHoverDate: _spauiUtils.PropTypes.func
});

_defineProperty(DatePanel, "defaultProps", {
  type: '',
  dateData: {},
  startData: {},
  endData: {},
  startDateDisabled: false,
  endDateDisabled: false
});

var _default = DatePanel;
exports["default"] = _default;